import { render, staticRenderFns } from "./CouncilMemberListCustom.vue?vue&type=template&id=27a3e0cc&"
import script from "./CouncilMemberListCustom.vue?vue&type=script&lang=js&"
export * from "./CouncilMemberListCustom.vue?vue&type=script&lang=js&"
import style0 from "./CouncilMemberListCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports